export default "__VITE_ASSET__KEzNdR2p__"